import sbx from "./envrionments/sbx";
import sbx_dr from "./envrionments/sbxDr";
import nonprod from "./envrionments/nonprod";
import nonprod_dr from "./envrionments/nonprodDr";
import prd from "./envrionments/prd";
import prod_dr from "./envrionments/prdDr";
import local from "./envrionments/local";

const config =
  process.env.REACT_APP_ENV === "prod"
    ? prd
    : process.env.REACT_APP_ENV === "prod-dr"
    ? prod_dr
    : process.env.REACT_APP_ENV === "staging"
    ? nonprod
    : process.env.REACT_APP_ENV === "staging-dr"
    ? nonprod_dr
    : process.env.REACT_APP_ENV === "dev"
    ? sbx
    : process.env.REACT_APP_ENV === "dev-dr"
    ? sbx_dr
    : local;

export default config;
